import { ModalFullscreen, Spinner } from '@cian/ui-kit';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './ChatModal.css';

export interface IChatModalProps {
  iframeSrc: string;
  isOpen: boolean;
  onClose(): void;
  onOpen?(): void;
}

export function ChatModal({ iframeSrc, isOpen, onClose, onOpen }: IChatModalProps) {
  const [isLoading, setIsLoading] = React.useState(true);
  const onLoad = () => setIsLoading(false);

  React.useEffect(() => {
    if (isOpen && onOpen) {
      onOpen();
    }
  }, [isOpen, onOpen]);

  return (
    <ModalFullscreen onClose={onClose} open={isOpen} theme="white">
      <div className={styles['iframe-container']}>
        <span className={styles['close']}>
          <IconActionClose16 color="icon-primary-default" onClick={onClose} />
        </span>
        {isLoading && (
          <span className={styles['spinner']} data-testid="spinner">
            <Spinner size={16} />
          </span>
        )}
        <iframe data-name="ChatModal" className={styles['iframe']} src={iframeSrc} onLoad={onLoad} onError={onLoad} />
      </div>
    </ModalFullscreen>
  );
}
